import React from 'react';
import Board from './components/Board';

function App() {
  return (
    <div className="App">
      <h1 className="header">TIC TAC TOE</h1>
      <Board />
    </div>
  );
}

export default App;
